import { EpRadarEntry } from "./TechRadar";
import { MovedState } from "@backstage-community/plugin-tech-radar-common";

export const radarEntriesByGroup: { [groupName: string]: Array<EpRadarEntry> } = {
    /**
     * Common Languages, Frameworks, Tools across different teams
     */
    common: [
        {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2022-06-03'),
                    description: 'adopt ',
                }
            ],
            url: '#',
            key: 'javascript',
            id: 'javascript',
            title: 'JavaScript',
            quadrant: 'languagesframeworks',
            description: 'JS is supported for both frontend and backend (Node.js)',
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2017-01-01'),
                    description: 'adopt ',
                }
            ],
            url: 'https://github.com/easyparkgroup/skeleton-nestjs',
            key: 'nodejs',
            id: 'nodejs',
            title: 'Node.js',
            quadrant: 'languagesframeworks',
            description: `Node.js is the golden path for implementing [bff pattern](https://backstage.easyparksystem.net/docs/default/domain/architecture/architecture-patterns/bff/#bff).
                Node.js has been used to write backend api-s that have a database, but this route is not officially supported and not on golden path. Use kotlin/java for backend golden path.`,
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2022-06-03'),
                    description: '',
                },
            ],
            url: '#',
            key: 'java',
            id: 'java',
            title: 'Java',
            quadrant: 'languagesframeworks',
            description: 'Java is the most widely used backend language in Easypark.',
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2022-06-03'),
                },
            ],
            url: 'https://github.com/easyparkgroup/skeleton',
            key: 'kotlin',
            id: 'kotlin',
            title: 'Kotlin',
            quadrant: 'languagesframeworks',
            description:
                `Kotlin is the default backend language and the default Android language. 
                Kotlin replaced Java as our golden path backend language in 2021.`,
        }, {
            timeline: [
                {
                    moved: MovedState.Up,
                    ringId: 'adopt',
                    date: new Date('2022-10-03'),
                    description:
                        `Currently [TypeScript](https://www.typescriptlang.org/) is not very widely used in Easypark. 
                        There are several projects, like 
                        [area-geo-server](https://github.com/easyparkgroup/area-geo-server), 
                        [smart-migration-proxy](https://github.com/easyparkgroup/smart-migration-proxy), 
                        [skeleton-nestjs](https://github.com/easyparkgroup/skeleton-nestjs), 
                        [ep-logger-nodejs](https://github.com/easyparkgroup/ep-logger-nodejs)
                        that already use TypeScript.
                        TypeScript makes it easier to write (autocomplete), understand (type information inferred or explicitly available) and refactor code (type-safety) compared to vanilla JavaScript,
                        that is essential for remaining productive in large or unfamiliar code-bases.
                        We have several developers with TypeScript experience.
                        It ranks in top of 
                        [wanted](https://survey.stackoverflow.co/2022/#most-loved-dreaded-and-wanted-language-want)
                        and [loved vs dreaded languages](https://survey.stackoverflow.co/2022/#most-loved-dreaded-and-wanted-language-love-dread)
                        in StackOverflow 2022 survey.
                        TypeScript was [used by 78% of the State of JS survey respondents, with 93% saying they would use it again](https://2020.stateofjs.com/en-US/technologies/javascript-flavors/).
                        `
                },
            ],
            url: 'https://www.typescriptlang.org/',
            key: 'typescript',
            id: 'typescript',
            title: 'TypeScript',
            quadrant: 'languagesframeworks',
            description:
                '',
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2022-06-03'),
                },
            ],
            url: 'https://reactjs.org/',
            key: 'react',
            id: 'react',
            title: 'React',
            quadrant: 'languagesframeworks',
            description: 'React is the only standard JS library for building user interfaces in Easypark'
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2022-06-03'),
                },
            ],
            url: 'https://github.com/easyparkgroup/skeleton',
            key: 'spring',
            id: 'spring',
            title: 'spring',
            quadrant: 'languagesframeworks',
            description: 'Spring and Spring Boot are the default backend frameworks for writing any API-s.',
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2022-06-03'),
                },
            ],
            url: 'https://expressjs.com/',
            key: 'expressjs',
            id: 'expressjs',
            title: 'Express',
            quadrant: 'languagesframeworks',
            description: 'Default nodejs framework for building backend-for-frontends',
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2022-06-03'),
                },
            ],
            url: 'https://easypark.jira.com/wiki/spaces/II/pages/1339752527/Kafka',
            key: 'kafka',
            id: 'kafka',
            title: 'Kafka',
            quadrant: 'infrastructure',
            description: 'Default streaming and message brokering service',
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'trial',
                    date: new Date('2022-08-10'),
                }
            ],
            url: 'https://oauth2-proxy.github.io/oauth2-proxy/',
            key: 'oauth2-proxy',
            id: 'oauth2-proxy',
            title: 'OAuth2 Proxy',
            quadrant: 'infrastructure',
            description: `OAuth2 Proxy to enable service usage without VPN.
        
        Usage example: https://github.com/easyparkgroup/backstage/blob/66552c04e80da347c06f06d78fe36bf04753cb7a/k8s/overlays/staging/ingress.yaml#L6-L7
        `,
        }, {
            timeline: [
                {
                    moved: MovedState.Up,
                    ringId: 'adopt',
                    date: new Date('2023-04-14'),
                },
                {
                    moved: MovedState.NoChange,
                    ringId: 'trial',
                    date: new Date('2023-04-14'),
                }
            ],
            url: 'https://easypark.jira.com/wiki/spaces/PET/pages/4146594036/Redis+Cluster+via+Helm',
            key: 'redis',
            id: 'redis',
            title: 'Redis',
            quadrant: 'infrastructure',
            description: `Redis is the default caching solution.
            `,
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'assess',
                    date: new Date('2023-04-14'),
                }
            ],
            url: 'https://github.com/easyparkgroup/auditlog/tree/master/_cloud/terraform',
            key: 'dynamodb',
            id: 'dynamodb',
            title: 'DynamoDB',
            quadrant: 'infrastructure',
            description: `DynamoDB is currently used in few specific cases that deal with huge amount of data. 
                DynamoDB is not recommended as general purpose database, for this please use Postgres. The challenge with DynamoDB 
                is that it's Amazons non-open-source compatible service - creating such a lock-in can only make sense if really well reasoned. 
                Most of the time, for fast-noSQL it's better to use Redis, for anything else Postgres. Dynamodb is not part of the 
                self-service platform offering - making it more difficult to configure. That said, the cost, global tables and 
                performance are acknowledged and if there is a good use case, it is possible (but hard) to use.  
           `,
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2022-08-10'),
                }
            ],
            url: 'https://library.humio.com/',
            key: 'humio',
            id: 'humio',
            title: 'Humio',
            quadrant: 'infrastructure',
            description: 'Log management and real-time observability.',
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2022-08-10'),
                }
            ],
            url: 'https://grafana.com/',
            key: 'grafana',
            id: 'grafana',
            title: 'Grafana',
            quadrant: 'infrastructure',
            description:
                `Dashboards and monitoring.
        
        Grafana: https://grafana.easyparkinfra.net/d/lqb4Ujliz/prometheus-infra-alerts?orgId=1
        `,
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2022-08-10'),
                }
            ],
            url: 'https://prometheus.io/',
            key: 'prometheus',
            id: 'prometheus',
            title: 'Prometheus',
            quadrant: 'infrastructure',
            description: 'Metrics collection and alerting',
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2024-11-15'),
                }
            ],
            url: 'https://grafana.com/oss/tempo/',
            key: 'tempo',
            id: 'tempo',
            title: 'Grafana Tempo',
            quadrant: 'infrastructure',
            description:
                `Distributed Tracing Solution from Grafana Labs.

                Helps you solve incidents faster,
                discover performance issues,
                where exactly errors are happening and why.
                Provides clear insights to understand what your application and other applications do internally
                when for example handling some HTTP request, Kafka message or executing DB calls.

                Integration with JVM or NodeJS based applications requires just one additional configuration line in your application Helm values file!
        
                See our documenation: https://easypark.jira.com/wiki/spaces/PRO/pages/4053467262/Distributed+tracing+with+OpenTelemetry+and+Grafana+Tempo
        `,
        }, {
            timeline: [
                {
                    moved: MovedState.NoChange,
                    ringId: 'adopt',
                    date: new Date('2022-08-10'),
                }
            ],
            url: 'https://docs.github.com/en/actions',
            key: 'github-actions',
            id: 'github-actions',
            title: 'Github Actions',
            quadrant: 'infrastructure',
            description:
                `Github Actions CI/CD.

        Example in skeleton: https://github.com/easyparkgroup/skeleton/tree/main/.github/workflows
        Self Hosted Setup: https://github.com/easyparkgroup/github-ci`,
        },
        {
            timeline: [
                {
                    moved: MovedState.Up,
                    ringId: 'adopt',
                    date: new Date('2025-02-13'),
                    description: '',
                },
                {
                    moved: MovedState.Up,
                    ringId: 'trial',
                    date: new Date('2023-08-09'),
                    description: '',
                }
            ],
            url: 'https://go.dev',
            key: 'Golang',
            id: 'Golang',
            title: 'Go',
            quadrant: 'languagesframeworks',
            description: `Go is one of the main backend languages at Easypark next to kotlin/java.
              There are several skeleton projects available at EasyPark to get teams started with new services:
              - [skeleton-go-restapi](https://github.com/easyparkgroup/skeleton-go-restapi)
              - [skeleton-go-grpc](https://github.com/easyparkgroup/skeleton-go-grpc)
              `
        },
        {
            id: 'python-be',
            url: 'https://www.python.org/',
            key: 'python-be',
            title: 'Python',
            quadrant: 'languagesframeworks',
            description: `Python is not supported as a backend language. See DATA quadrant for how it's doing in scripting`,
            timeline: [{ moved: MovedState.NoChange, ringId: 'hold', date: new Date('2022-09-08') }]
        },
        {
            id: 'C#',
            url: 'https://learn.microsoft.com/en-us/dotnet/csharp/tour-of-csharp/',
            key: 'csharp',
            title: 'C#',
            quadrant: 'languagesframeworks',
            description: `C# is not supported as a backend language. A few selected C# build Parkmobile US services will be integrated into the global platform. No new development should be based on C#/.NET`,
            timeline: [{ moved: MovedState.NoChange, ringId: 'hold', date: new Date('2023-11-08') }]
        }
    ],
    mobile: [
        {
            id: 'firebaseappdistribution',
            url: 'https://firebase.google.com/docs/app-distribution',
            key: 'firebaseappdistribution',
            title: 'FirebaseAppDistribution',
            quadrant: 'infrastructure',
            description: 'We are consolidating our mobile app distrubution tools and will use only FireBase App Distribution.',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2023-10-11') }]
        },
        {
            id: 'appcenter',
            url: 'https://appcenter.ms',
            key: 'appcenter',
            title: 'AppCenter',
            quadrant: 'infrastructure',
            description: 'Microsoft solution for distributing apps. We are  consolidating our mobile app distrubution tools and will use FireBase App Distribution instead of AppCenter.',
            timeline: [{ moved: MovedState.NoChange, ringId: 'hold', date: new Date('2023-10-11') }]
        },
        {
            id: 'swift',
            url: 'https://www.swift.org/',
            key: 'swift',
            title: 'Swift',
            quadrant: 'languagesframeworks',
            description: 'Swift programming language for iOS development',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2022-06-07') }]
        },
        {
            id: 'jetpackcompose',
            url: 'https://developer.android.com/jetpack/compose',
            key: 'jetpackcompose',
            title: 'Jetpack Compose',
            quadrant: 'languagesframeworks',
            description: 'Declarative UI framework for android development',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2022-06-07') }]
        },
        {
            id: 'swiftui',
            url: 'https://developer.apple.com/xcode/swiftui/',
            key: 'swiftui',
            title: 'SwiftUI',
            quadrant: 'languagesframeworks',
            description: 'Declarative UI framework for iOS development',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2022-06-07') }]
        },
        {
            id: 'uikit',
            url: 'https://developer.apple.com/documentation/uikit',
            key: 'uikit',
            title: 'UIKit',
            quadrant: 'languagesframeworks',
            description: 'Imperative UI framework for iOS development',
            timeline: [{ moved: MovedState.NoChange, ringId: 'hold', date: new Date('2022-06-07') }]
        },
        {
            id: 'androidview',
            url: 'https://developer.android.com/reference/android/view/View',
            key: 'androidview',
            title: 'Android View',
            quadrant: 'languagesframeworks',
            description: 'Imperative UI framework for android development',
            timeline: [{ moved: MovedState.NoChange, ringId: 'hold', date: new Date('2022-06-07') }]
        }
    ],
    dataEnginering: [
        {
            id: 'python',
            url: 'https://www.python.org/',
            key: 'python',
            title: 'Python',
            quadrant: 'data',
            description: 'Python is widely used for custom data pipelines',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2022-07-26') }]
        },
        {
            id: 'snowflake',
            url: 'https://www.snowflake.com/',
            key: 'snowflake',
            title: 'Snowflake',
            quadrant: 'data',
            description: 'Data warehouse',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2022-07-26') }]
        },
        {
            id: 'looker',
            url: 'https://www.looker.com/',
            key: 'looker',
            title: 'Looker',
            quadrant: 'data',
            description: 'BI & analytics visualisation',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2022-07-26') }]
        },
        {
            id: 'dbt',
            url: 'https://www.getdbt.com/',
            key: 'dbt',
            title: 'dbt',
            quadrant: 'data',
            description: 'Data transformation and testing',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2022-07-26') }]
        },
        {
            id: 'fivetran',
            url: 'https://easypark.jira.com/wiki/spaces/DP/pages/3870425398/Fivetran',
            key: 'fivetran',
            title: 'Fivetran',
            quadrant: 'data',
            description: 'ELT platform. Replaces pipelinewise for CDC from operational databases to Snowflake. Is used for ETL purposes into Snowflake also elsewhere.',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2023-02-14') }]
        },
        {
            id: 'braze',
            url: 'https://www.braze.com/',
            key: 'braze',
            title: 'Braze',
            quadrant: 'data',
            description: 'Customer engagement platform',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2022-07-26') }]
        },
        {
            id: 'brazecurrents',
            url: 'https://www.braze.com/docs/user_guide/data_and_analytics/braze_currents',
            key: 'brazecurrents',
            title: 'Braze Currents',
            quadrant: 'data',
            description: 'Continuous data streams from Braze',
            timeline: [{ moved: MovedState.NoChange, ringId: 'hold', date: new Date('2022-07-26') }]
        },
        {
            id: 'mixpanel',
            url: 'https://mixpanel.com/',
            key: 'mixpanel',
            title: 'Mixpanel',
            quadrant: 'data',
            description: 'Customer engagement platform',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2022-07-26') }]
        },
        {
            id: 'awss3',
            url: 'https://aws.amazon.com/s3/',
            key: 'awss3',
            title: 'AWS S3',
            quadrant: 'data',
            description: 'Object storage',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2022-07-26') }]
        },
        {
            id: 'pipelinewise',
            url: 'https://github.com/transferwise/pipelinewise',
            key: 'pipelinewise',
            title: 'Pipelinewise',
            quadrant: 'data',
            description: 'Data pipeline framework',
            timeline: [{ moved: MovedState.NoChange, ringId: 'hold', date: new Date('2022-07-26') }]
        },
        {
            id: 'airflow',
            url: 'https://airflow.apache.org/',
            key: 'airflow',
            title: 'Airflow',
            quadrant: 'data',
            description: 'Workflow scheduling',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2022-07-26') }]
        },
    ],
    techniques: [
        {
            id: 'tbd-pr',
            url: 'https://trunkbaseddevelopment.com/#scaled-trunk-based-development',
            key: 'tbd-pr',
            title: 'Github short lived branches',
            quadrant: 'techniques',
            description: 'This is a potentially the new default way of working with code reviews.',
            timeline: [{ moved: MovedState.NoChange, ringId: 'trial', date: new Date('2022-08-08') }]
        },
        {
            id: 'debezium',
            url: 'slack://channel?team=T041C41CF&id=C022QTW0F53',
            key: 'debezium',
            title: 'Debezium CDC',
            quadrant: 'techniques',
            description: 'It is a great way how to get data from database to kafka, however it has known high availability challenges.' +
                'Check the slack channel #debezium-kafka-connect for more information',
            timeline: [{ moved: MovedState.NoChange, ringId: 'assess', date: new Date('2022-08-08') }]
        },
        {
            id: 'kafka-connect',
            url: 'https://github.com/easyparkgroup/ep-kafka-connect',
            key: 'kafka-connect',
            title: 'Kafka connect',
            quadrant: 'techniques',
            description: 'Kafka connect is a great way how to get data in/out of kafka. Only problem is that this project' +
                'does not have a clear owner and therefore no SLA',
            timeline: [{ moved: MovedState.NoChange, ringId: 'trial', date: new Date('2022-08-08') }]
        },
        {
            id: 'kustomize',
            url: 'https://kustomize.io/',
            key: 'kustomize',
            title: 'Kustomize',
            quadrant: 'techniques',
            description: `For deploying applications its recommended to use helm.
                Kustomize can be used in conjunction with helm if off the shelf helm chart needs to be modified because of lack of flexibility.
                To overcome this problem it is possible to https://helm.sh/docs/topics/advanced/#post-rendering technique.`,
            timeline: [
                {
                    moved: MovedState.Down,
                    ringId: 'hold',
                    date: new Date('2022-08-11')
                }
            ]
        },
        {
            id: 'mvc-mobile',
            url: 'https://developer.apple.com/library/archive/documentation/General/Conceptual/DevPedia-CocoaCore/MVC.html',
            key: 'mvc-mobile',
            title: 'MVC pattern for iOS mobile development',
            quadrant: 'techniques',
            description: 'Should instead follow the best practices in SwiftUI',
            timeline: [{ moved: MovedState.NoChange, ringId: 'hold', date: new Date('2022-08-08') }]
        },
        {
            id: 'mvp-mobile',
            url: 'https://developer.android.com/jetpack/compose/interop/compose-in-existing-arch',
            key: 'mvp-mobile',
            title: 'MVP pattern for Android mobile development',
            quadrant: 'techniques',
            description: 'Should instead follow the best practices in Jetpack Compose',
            timeline: [{ moved: MovedState.NoChange, ringId: 'hold', date: new Date('2022-08-08') }]
        },
        {
            id: 'json-logging',
            url: '',
            key: 'json-logging',
            title: 'JSON Logging',
            quadrant: 'techniques',
            description: 'Exporting application and service logs in JSON format for easier processing by log management.',
            timeline: [{ moved: MovedState.NoChange, ringId: 'trial', date: new Date('2022-08-11') }]
        },
        {
            id: 'grpc',
            url: 'https://grpc.io/',
            key: 'grpc',
            title: 'gRPC',
            quadrant: 'techniques',
            description: `Easypark internal and external default way for API communication is REST+JSON. 
                We have had some PoC-s with gRPC+protobuf but nothing serious - on hold now. 
                Now we also have some applications in Parkmobile US who are also using gRPC as a natural choice for golang. 
                gRPC is however in assess, which means it's interesting and there is potential for it going forward, but there 
                are known limitations, such as missing tooling, experience and support. 
                It is OK to use gRPC internally within a team, when you own both ends of the communication. 
                For API-s that are meant for use by other teams, we should use REST+JSON as default choice. 
                The main reason for this is that it's better to have only one standard, even if the standard is not perfect. 
                If we choose to start building all cross-team API-s on gRPC we should take a holistic view of what the pros and cons are, 
                what is doable from roadmap perspective and what is the migration plan.`,
            timeline: [{ moved: MovedState.NoChange, ringId: 'assess', date: new Date('2023-04-12') }]
        },
        {
            id: 'helm',
            url: 'https://helm.sh/',
            key: 'helm',
            title: 'Helm',
            quadrant: 'techniques',
            description: `Easypark default way of deploying applications to kubernetes.
                Check https://github.com/easyparkgroup/helm-starters and https://github.com/easyparkgroup/skeleton/tree/main/k8s/helm for examples.`,
            timeline: [
                {
                    moved: MovedState.Up,
                    ringId: 'adopt',
                    date: new Date('2023-08-21')
                }
            ]
        }
    ],
    security: [
        {
            id: 'zap',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/4525621442/',
            key: 'zap',
            title: 'Zed Attack Proxy',
            quadrant: 'infrastructure',
            description:
                `The Zed Attack Proxy can help you automatically find security vulnerabilities in your web applications.
                Confluence: https://easypark.jira.com/wiki/spaces/SEC/pages/4525621442/
                ZAProxy Source: https://www.zaproxy.org/`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'assess',
                date: new Date('2024-04-01')
            }]
        },
        {
            id: 'gotestwaf',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/4525621338/',
            key: 'gotestwaf',
            title: 'GoTestWAF',
            quadrant: 'infrastructure',
            description:
                `GoTestWAF is a tool for API and OWASP attack simulation that supports a wide range of API protocols
                Confluence: https://easypark.jira.com/wiki/spaces/SEC/pages/4525621338/
                GitHub Source: https://github.com/wallarm/gotestwaf`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'assess',
                date: new Date('2024-04-01')
            }]
        },
        {
            id: 'github-advanced-security',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/3675389973/',
            key: 'github-advanced-security',
            title: 'GitHub Advanced Security',
            quadrant: 'techniques',
            description:
                `Github Advanced Security provides additional security features in GitHub.
                Confluence: https://easypark.jira.com/wiki/spaces/SEC/pages/3675389973/
                GitHub Source: https://docs.github.com/en/get-started/learning-about-github/about-github-advanced-security`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'adopt',
                date: new Date('2023-08-08'),
            }],
        },
        {
            id: 'awsSigner',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/4247093249/',
            key: 'awsSigner',
            title: 'AWS Signer',
            quadrant: 'infrastructure',
            description:
                `Used to sign container images in combination with Notation
                Confluence: https://easypark.jira.com/wiki/spaces/SEC/pages/4247093249
                AWS Source: https://docs.aws.amazon.com/signer/`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'assess',
                date: new Date('2024-01-01')
            }]
        },
        {
            id: 'notation',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/4247093249/Container+Image+Signatures',
            key: 'notation',
            title: 'Notation',
            quadrant: 'infrastructure',
            description:
                `Notation is a CLI project to add signatures as standard items in the OCI registry ecosystem.
                Confluence: https://easypark.jira.com/wiki/spaces/SEC/pages/4247093249
                GitHub Source: https://github.com/notaryproject/notation`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'assess',
                date: new Date('2024-01-01')
            }]
        },
        {
            id: 'awsShieldAdvanced',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/3765043236/',
            key: 'shield',
            title: 'AWS Shield Advanced',
            quadrant: 'infrastructure',
            description:
                `Distributed Denial of Service protection offered by AWS, works in combination with Web Application Firewall
                Confluence: https://easypark.jira.com/wiki/spaces/SEC/pages/3765043236/
                AWS Source: https://aws.amazon.com/shield/`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'adopt',
                date: new Date('2022-08-24')
            }]
        },
        {
            id: 'awsWaf',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/4213276870',
            key: 'waf',
            title: 'AWS WAF',
            quadrant: 'infrastructure',
            description:
                `AWS Web Application Firewall for resources like LoadBalancer, CloudFront, API GateWay etc.
                Confluence: https://easypark.jira.com/wiki/spaces/SEC/pages/4213276870
                AWS Source: https://aws.amazon.com/waf/`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'adopt',
                date: new Date('2023-11-01')
            }]
        },
        {
            id: 'awsGuardDuty',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/3762651184/',
            key: 'guardduty',
            title: 'AWS GuardDuty',
            quadrant: 'infrastructure',
            description:
                `Automatic scan for anomalies from logs in AWS.
                Confluence: https://easypark.jira.com/wiki/spaces/SEC/pages/3762651184/
                AWS Source: https://aws.amazon.com/guardduty/`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'adopt',
                date: new Date('2022-08-24')
            }]
        },
        {
            id: 'awsSecurityHub',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/3760980057  ',
            key: 'sechub',
            title: 'AWS Security Hub',
            quadrant: 'techniques',
            description:
                `AWS security dashboard that uses GuardDuty, Inspector, Macie etc. as source.
                Confluence: https://easypark.jira.com/wiki/spaces/SEC/pages/3760980057/
                AWS Source: https://aws.amazon.com/security-hub/`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'adopt',
                date: new Date('2022-08-24')
            }]
        },
        {
            id: 'awsSecretsManager',
            url: 'https://aws.amazon.com/secrets-manager/',
            key: 'secrets',
            title: 'AWS Secrets Manager',
            quadrant: 'infrastructure',
            description:
                `Secrets key/value store. Can automatically rotate secrets.
                AWS Source: https://aws.amazon.com/secrets-manager/`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'adopt',
                date: new Date('2022-08-24')
            }]
        },
        {
            id: 'awsCloudTrail',
            url: 'https://aws.amazon.com/cloudtrail/',
            key: 'cloudtrail',
            title: 'AWS Cloudtrail',
            quadrant: 'infrastructure',
            description:
                `Track user activity and API usage on AWS.
                AWS Source: https://aws.amazon.com/cloudtrail/`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'adopt',
                date: new Date('2022-08-24')
            }]
        },
        {
            id: 'awsInspector',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/3782606907/',
            key: 'inspector',
            title: 'AWS Inspector',
            quadrant: 'infrastructure',
            description:
                `Amazon Inspector is a vulnerability management service that continually scans ECR images.
                Confluence: https://easypark.jira.com/wiki/spaces/SEC/pages/3782606907/
                AWS Source: https://aws.amazon.com/inspector/`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'adopt',
                date: new Date('2023-11-01')
            }]
        },
        {
            id: 'dependabot',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/3771039747/',
            key: 'dependabot',
            title: 'Dependabot',
            quadrant: 'infrastructure',
            description:
                `Automated dependency scanner in GitHub.
                Confluence: https://easypark.jira.com/wiki/spaces/SEC/pages/3771039747/
                GitHub Source: https://docs.github.com/en/code-security/dependabot/dependabot-alerts/viewing-and-updating-dependabot-alerts`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'adopt',
                date: new Date('2022-08-24')
            }]
        },
        {
            id: 'trivy',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/3789717593',
            key: 'trivy',
            title: 'Trivy',
            quadrant: 'infrastructure',
            description:
                `Free and Open Source Software vulnerability, compliance and secret scanning tool.
                Confluence Container Image Scan: https://easypark.jira.com/wiki/spaces/SEC/pages/3789717593/
                Confluence Repository Scan: https://easypark.jira.com/wiki/spaces/SEC/pages/4793925659
                Aqua Security Source: https://www.aquasec.com/products/trivy/`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'adopt',
                date: new Date('2023-11-01')
            }]
        },
        {
            id: 'tripwire',
            url: '',
            key: 'fim',
            title: 'Tripwire (FIM)',
            quadrant: 'infrastructure',
            description:
                `DEPRECATED in favor of NeuVector file integrity monitoring.
                File integrity monitoring.
                GitHub Source: https://github.com/Tripwire/tripwire-open-source`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'hold',
                date: new Date('2022-08-24')
            }]
        },
        {
            id: 'neuvector',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/4027744279/NeuVector',
            key: 'neuvector',
            title: 'Neuvector',
            quadrant: 'infrastructure',
            description:
                `Container Security Platform.
                https://open-docs.neuvector.com/`,
            timeline: [{
                moved: MovedState.Down,
                ringId: 'hold',
                date: new Date('2023-11-01')
            }]
        },
        {
            id: 'codeql',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/4038918265/',
            key: 'codeql',
            title: 'CodeQL',
            quadrant: 'infrastructure',
            description:
                `Code analysis engine developed by GitHub to automate security checks.
                Confluence: https://easypark.jira.com/wiki/spaces/SEC/pages/4038918265/
                GitHub Source: https://codeql.github.com/`,
            timeline: [{
                moved: MovedState.NoChange,
                ringId: 'adopt',
                date: new Date('2023-11-01')
            }]
        }
    ],
    platformEngineering: [
        {
            id: 'Spacelift',
            url: 'https://spacelift.io/',
            key: 'Spacelift',
            title: 'Spacelift',
            quadrant: 'infrastructure',
            description: 'Spacelift helps to put some sense into Terraform pipelines.',
            timeline: [{ moved: MovedState.NoChange, ringId: 'assess', date: new Date('2022-09-02') }]
        },
        {
            id: 'Ansible',
            url: 'https://www.ansible.com/',
            key: 'Ansible',
            title: 'Ansible',
            quadrant: 'infrastructure',
            description: 'Oldschool infrastructure management',
            timeline: [{ moved: MovedState.NoChange, ringId: 'hold', date: new Date('2022-09-02') }]
        },
        {
            id: 'GitOps',
            url: 'https://codefresh.io/learn/gitops/',
            key: 'GitOps',
            title: 'GitOps',
            quadrant: 'techniques',
            description: 'TODO',
            timeline: [{ moved: MovedState.NoChange, ringId: 'trial', date: new Date('2022-09-02') }]
        },
        {
            id: 'Crossplane',
            url: 'https://easypark.jira.com/wiki/spaces/PET/pages/4136763562/Crossplane+guidelines',
            key: 'Crossplane',
            title: 'Crossplane',
            quadrant: 'infrastructure',
            description: 'Tool for managing cloud resources from Kubernetes',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2023-06-02') }]
        },
        {
            id: 'EKS',
            url: 'https://easypark.jira.com/wiki/spaces/PET/pages/3708715089/EKS',
            key: 'EKS',
            title: 'EKS',
            quadrant: 'infrastructure',
            description: 'Amazon Elastic Kubernetes Service (EKS) is a cloud-based container management service that natively integrates with Kubernetes to deploy applications',
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2024-01-07') }]
        },
        {
            id: 'Mimir',
            url: 'https://grafana.com/oss/mimir/',
            key: 'Mimir',
            title: 'Mimir',
            quadrant: 'infrastructure',
            description: 'TODO',
            timeline: [{ moved: MovedState.NoChange, ringId: 'trial', date: new Date('2022-09-02') }]
        },
        {
            id: 'kyverno',
            url: 'https://easypark.jira.com/wiki/spaces/SEC/pages/4221698135/Kyverno',
            key: 'kyverno',
            title: 'Kyverno',
            quadrant: 'infrastructure',
            description:
                `Policy engine designed for Kubernetes.

https://kyverno.io/
`,
            timeline: [{ moved: MovedState.NoChange, ringId: 'trial', date: new Date('2023-11-01') }]
        },
        {
            id: 'LaunchDarkly',
            url: 'https://easypark.jira.com/wiki/spaces/EPA/pages/4124835983/LaunchDarkly',
            key: 'launchdarkly',
            title: 'LaunchDarkly',
            quadrant: 'infrastructure',
            description: `Feature flagging and AB testing tool primarily in use in Drivers for mobile apps. https://launchdarkly.com/`,
            timeline: [{ moved: MovedState.NoChange, ringId: 'adopt', date: new Date('2023-10-01') }]
        },
        {
            id: 'Flow.Swiss',
            url: 'https://easypark.jira.com/wiki/spaces/EPA/pages/5497913345/Flow.Swiss',
            key: 'flowswiss',
            title: 'Flow.Swiss',
            quadrant: 'infrastructure',
            description: `Mac machine hosting for iOS builds. https://flow.swiss/`,
            timeline: [{ moved: MovedState.NoChange, ringId: 'trial', date: new Date('2025-08-20') }]
        }
    ]
}
